import {
  THEME_REQUEST,
  THEME_RESET,
} from './actionTypes';
import GlobalBaseTheme from '../globalBaseTheme';

export default function reducer(state = GlobalBaseTheme, action) {
  switch (action.type) {
    case THEME_REQUEST:
      return {
        ...state,
        ...action.theme,
      };
    case THEME_RESET:
      return {
        ...GlobalBaseTheme,
      };
    default:
      return state;
  }
}

// actions
export function updateTheme(theme) {
  return {
    type: THEME_REQUEST,
    theme,
  };
}
export function resetTheme() {
  return {
    type: THEME_RESET,
  };
}
